import React from "react";

/* COMPONENTS */
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import ServicesSection from "../components/ServicesSection";
import ProjectsSection from "../components/ProjectsSection";
import TestimonialSection from "../components/TestimonialSection";
import WhyChooseSection from "../components/WhyChooseSection";
import PricingSection from "../components/PricingSection";
import FAQSection from "../components/FAQSection";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <>
      <Navbar />

      <Hero />

      <About />

      <ServicesSection />

      <ProjectsSection />

      <TestimonialSection />

      <WhyChooseSection />

      <PricingSection />

      <FAQSection />

      <Footer />
    </>
  );
};

export default Home;